import React, {useContext,useEffect,useState} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia} from '@mui/material'
import Axios from 'axios'
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import {NuevaInscripcionNew} from './NuevaInscripcionNew'
import { DatosPersonalesMinExterno } from './DatosPersonalesMinExterno';
import {useHelper} from '../hooks/useHelper';

export const ETSolicitaDatosPersona = ({tipoItemPersona})=>{
    const { datos,infoMinistro,
        handleChangeDocumento,
        reinicializar,
        datosMinistroOk,
        buscarDatosMinistro,validarTokenMinistro
} = useContext(formularioContext)
        const [loading,setLoading]=useState(false);
        const {getToken} = useHelper();

    useEffect(async ()=>{
        const tokenmin = getToken();
        if(tokenmin){
            const dnitoken = await validarTokenMinistro(tokenmin)

            if(dnitoken && tipoItemPersona=='uad'){
                await handleChangeDocumento({target:{value:Number(dnitoken).toString()}})
            }
         }
    },[])

    const validarDNI = ()=>{
        setLoading(true)
        buscarDatosMinistro() // sea ministro uad o no voy a verificar que el DNI está en la base de datos
        .then(info=>{
            if(!info){
                setLoading(false)
            }else{
               setLoading(false)
            }
        })
        .catch(err=>{
            setLoading(false)
            Swal.fire({
                html:`<p>${err.message}</p>`,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            }) 
        })
    }

    const processHandleChangeDNI = (e)=>{
        handleChangeDocumento(e)
    }

    return  <Box sx={{mt:2,mb:2}}>
            {!datos.ministroUad && <>
            <Typography variant="subtitle1">{tipoItemPersona!='uad' ? 'Cargá tus datos para continuar con la inscripción:' :'Cargá tus datos para continuar con la inscripción:'}</Typography>
                {tipoItemPersona=='uad' && <Box
                    sx={{
                    marginTop: '1rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    width: '200px',
                    }}
                >
                    <TextField
                    autoFocus
                    value={datos.documento}
                    onChange={(e) => processHandleChangeDNI(e)}
                    fullWidth
                    id="ub-dni"
                    inputProps={{ maxLength: 9, placeholder: 'DNI' }}
                    label="Ingrese su DNI"
                    variant="outlined"
                    />

                        <Box sx={{ width: '100%' }}>
                            <Button
                            title="Continuar"
                            disabled={
                                datos.documento.trim() === '' || datos.documento.trim().length < 7
                            }
                            variant="contained"
                            color="primary"
                            sx={{
                                width: '100%',
                                backgroundColor: '#1976d2', 
                                color: 'white',
                                '&:hover': {
                                backgroundColor: '#1565c0', 
                                },
                            }}
                            onClick={validarDNI}
                            >
                            Continuar
                            </Button>
                        </Box>
                </Box>}
                {tipoItemPersona!='uad' &&  
                <Box sx={{display:'flex',flexDirection:'column',maxWidth:'500px'}}>
                    <DatosPersonalesMinExterno/>
                    {!datosMinistroOk()[0] && <Typography sx={{fontSize:'medium',color:'firebrick',marginTop:'1rem',marginLeft:'1.5rem'}} variant="subtitle">{datosMinistroOk()[1]}</Typography>}
                    {datosMinistroOk()[0] && <Button onClick={validarDNI} sx={{width:'100%'}} variant='contained'>
                        Continuar
                    </Button>}
                </Box>
                }
                </>}
        </Box>
}

